export const MENU_ITEM = [
    { id: 'main', path: '/', exact: true },
    { id: 'products', path: '/products', exact: true },
    { id: 'delivery', path: '/delivery', exact: true },
    { id: 'about', path: '/about', exact: true },
    { id: 'advantages', path: '/advantages', exact: true },
    { id: 'contacts', path: '/contacts', exact: true },
];

